namespace RedBullMOBILE360.SpecialEvent {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.SpecialEvent.SpecialEventGrid')
    export class SpecialEventGrid extends Serenity.EntityGrid<SpecialEventRow, any> {
        protected getColumnsKey() { return SpecialEventColumns.columnsKey; }
        protected getDialogType() { return SpecialEventDialog; }
        protected getIdProperty() { return SpecialEventRow.idProperty; }
        protected getInsertPermission() { return SpecialEventRow.insertPermission; }
        protected getLocalTextPrefix() { return SpecialEventRow.localTextPrefix; }
        protected getService() { return SpecialEventService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        /*protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //if (!Q.Authorization.userDefinition.IsAdmin)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push({
                title: 'Upload Event Image',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new SpecialEventImportDialog();
                    dialog.dialogOpen();
                }
            });

            return buttons;
        }*/

        protected getButtons() {
            var buttons = super.getButtons();

            if (!Q.Authorization.hasPermission("Adminstration:General")) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            }

            return buttons;
        }


        protected getColumns() {
            var columns = super.getColumns();

            if (Q.Authorization.hasPermission("SpecialEvent:Generate")) {
                columns.push({
                    field: 'Id',
                    name: '',
                    width: 200,
                    format: ctx => {
                        return `<form action="/SpecialEvent/GenerateCustomImage/" method="get">
                        <div class="d-flex align-items-center gap-2 me-5">
                        <input placeholder="إسمك باللغة العربية" class="small h-50" id="personname" name="personname" type="text">
                        <input class="d-none" name="ImageId" value="`+ ctx.value + `" type="text">
                        <input class="d-none" name="lang" value="ar" type="text">
                        <button class="text-danger p-0 btn fw-bold" type="submit" data-bs-toggle="tooltip" data-bs-placement="top" title="Download image"> <i class="fa fa-download fs-3" aria-hidden="true"></i> </button>
                        </div>
                        </form>`;
                        /*return '<input id="personname" class="shadow" placeholder="Type your name" onSubmit="location.href=\'/SpecialEvent/GenerateImages/?ImageId=' + ctx.value + '\';" />';*/
                        /*return '<input type="text" id="personname" placeholder="Type your name"></input><a href="/SpecialEvent/GenerateImages/?ImageId=' + ctx.value + '"> <i class="fas fa-gift"></i> </a>';*/
                    }
                }),
                    columns.push({
                        field: 'Id',
                        name: '',
                        width: 200,
                        format: ctx => {
                            return `<form action="/SpecialEvent/GenerateCustomImage/" method="get">
                        <div class="d-flex align-items-center gap-2 me-5">
                        <input placeholder="Your name in English" class="small h-50" id="personname" name="personname" type="text">
                        <input class="d-none" name="ImageId" value="`+ ctx.value + `" type="text">
                        <input class="d-none" name="lang" value="en" type="text">
                        <button class="text-danger p-0 btn fw-bold" type="submit" data-bs-toggle="tooltip" data-bs-placement="top" title="Download image"> <i class="fa fa-download fs-3" aria-hidden="true"></i> </button>
                        </div>
                        </form>`;
                            /*return '<input id="personname" class="shadow" placeholder="Type your name" onSubmit="location.href=\'/SpecialEvent/GenerateImages/?ImageId=' + ctx.value + '\';" />';*/
                            /*return '<input type="text" id="personname" placeholder="Type your name"></input><a href="/SpecialEvent/GenerateImages/?ImageId=' + ctx.value + '"> <i class="fas fa-gift"></i> </a>';*/
                        }
                    });
            }

            return columns;
        }

        /*protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
            var dlg = this;
            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();
                var opt: any;

                if (target.hasClass('edit')) {
                    opt = {
                        Id: item.Id,
                        ImageUrl: item.ImageUrl,
                        grid: dlg
                    };
                    new EditImageDialog().dialogOpen();
                }
            }
        }*/

    }
}